import React, { Component, Fragment } from "react";

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import utils from "../../../utils/utils";

import Select from "../../Relatorio1/Select";
import Radio from "../../Relatorio1/Radio";

import util from "../Util/util";

import Grafico from "../../Grafico";
import Grafico2 from "../../Grafico2";
import Grafico3 from "../../Grafico3";
import Grafico4 from "../../Grafico4";
import Navbar from "../../../Realizado/UI/Navbar";
import NomeUnidade from "../../../../UI/NomeUnidade";
import MenuRelatorioEP from "../../../../../pages/ProducaoEP/menuRelatorioEP";

export default class IndexTesteNovoJSON extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            dados: [],
            realizados: {},
            acumulado: {},
            mesSelecionado: "janeiro",
            isAcumulado: false,
            radioChecked: "mes"
        }
    }

    async componentDidMount() {
        await this.getDados();
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.isAcumulado !== this.state.isAcumulado || prevState.mesSelecionado !== this.state.mesSelecionado) {
            await this.getDados();
        }
    }

    getDados = async () => {
        let { dados, realizados, acumulado } = await util.fetchDados(this.state.mesSelecionado, this.state.isAcumulado);
        this.setState({ dados, realizados, acumulado });
    }

    selectMes = (event) => {
        this.setState({ mesSelecionado: event.target.value })
    }

    onChange = async (event) => {
        let isAcumulado = event.target.value === "acumulado" ? true : false;
        this.setState({ isAcumulado, radioChecked: event.target.value })
    }

    calculaTotal = (dados, mes=0) => {

        let valorRealizado = { ...dados.realizados }
        dados = { ...dados.metas }

        let total = {
            matricula_regimental: 0,
            matricula_nao_regimental: 0,
            matricula_pago: 0,
            hora_regimental: 0,
            hora_nao_regimental: 0,
            hora_pago: 0,
            r_matricula_regimental: 0,
            r_matricula_nao_regimental: 0,
            r_matricula_pago: 0,
            r_hora_regimental: 0,
            r_hora_nao_regimental: 0,
            r_hora_pago: 0,
        }

        if (dados) {
            Object.keys(dados).map((modalidade, i) => {
                total["matricula_regimental"]     += dados[modalidade]["matricula_regimental"][mes]
                total["matricula_nao_regimental"] += dados[modalidade]["matricula_nao_regimental"][mes]
                total["matricula_pago"]           += dados[modalidade]["matricula_pago"][mes]
                total["hora_regimental"]          += dados[modalidade]["hora_regimental"][mes]
                total["hora_nao_regimental"]      += dados[modalidade]["hora_nao_regimental"][mes]
                total["hora_pago"]                += dados[modalidade]["hora_pago"][mes]
            });
        }
        
        
        if (valorRealizado) {
            Object.keys(valorRealizado).map((modalidade, i) => {
                total["r_matricula_regimental"]     += valorRealizado[modalidade]["matricula_regimental"][mes]
                total["r_matricula_nao_regimental"] += valorRealizado[modalidade]["matricula_nao_regimental"][mes]
                total["r_matricula_pago"]           += valorRealizado[modalidade]["matricula_pago"][mes]
                total["r_hora_regimental"]          += valorRealizado[modalidade]["hora_regimental"][mes]
                total["r_hora_nao_regimental"]      += valorRealizado[modalidade]["hora_nao_regimental"][mes]
                total["r_hora_pago"]                += valorRealizado[modalidade]["hora_pago"][mes]
            });
        }
        
        return total;

    }

    formataNumeroNovo = (num, atributo, mes, soma=false, tipo) => {
        try {
            let numero;
            if(soma) {
                numero = num[`${tipo}_pago`][mes] + num[`${tipo}_nao_regimental`][mes] + num[`${tipo}_regimental`][mes];
            }
            else {
                numero = num[atributo][mes];
            }
            return numero.toLocaleString('pt-BR');
        } catch (error) {
            return 0;
        }
    }

    formataPercentual = (valorMeta, valorRealizado, atributo, mes) => {
        try {
            let totalMeta = valorMeta[`${atributo}_pago`][mes] + valorMeta[`${atributo}_nao_regimental`][mes] + valorMeta[`${atributo}_regimental`][mes];
            let totalRealizado = valorRealizado[`${atributo}_pago`][mes] + valorRealizado[`${atributo}_nao_regimental`][mes] + valorRealizado[`${atributo}_regimental`][mes];
            let percentual = totalMeta === 0 ? 0 : totalRealizado / totalMeta;
            return percentual.toLocaleString('pt-BR', { style: 'percent' });
        } catch (error) {
            return 0;
        }
    }

    render() {

        let { dados, mesSelecionado, realizados, isAcumulado, radioChecked, acumulado } = this.state;
        let totais;

        if (isAcumulado) {
            dados = { ...acumulado }
        }

        let meses = ["janeiro", "fevereiro", "marco", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
        mesSelecionado = meses.indexOf(mesSelecionado);

        return (
            <Fragment>

                <NomeUnidade unidade={"Relatórios"} />

                {/*
                <div className="container-sm mt-4">
                    <div className="card">
                        <div className="card-header">
                            Opções
                        </div>
                        <div className="card-body">
                            <Select selectMes={this.selectMes} />
                            <Radio onChange={this.onChange} radioChecked={radioChecked} />
                        </div>
                    </div>
                </div>
                
                <div className="mt-5 container-fluid" style={{ maxWidth: "95%" }}>
                    <Grafico />
                </div>
                
                <div className="mt-5 container-fluid" style={{ maxWidth: "95%" }}>
                    <Grafico2 />
                </div>
                */}

                <div className="content">
                    <MenuRelatorioEP />
                    <div className="row">
                        <div className="col-md-12">

                            <Grafico4 />

                            <Tabs defaultActiveKey={"DR"}>

                                {dados.map((valor, i) => {

                                    let total = this.calculaTotal(valor, mesSelecionado);

                                    let { sigla } = utils.getUnidade(valor.unidade);

                                    return (
                                        <Tab eventKey={sigla} title={sigla}>

                                            <Fragment>
                                                <div className="table-responsive">
                                                    <table border="1" className="table table-bordered table-hover table-sm table-striped text-center">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan="19" className="text-center">{valor.unidade}</th>
                                                            </tr>
                                                            <tr>
                                                                <th rowSpan="4">Modalidades</th>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan="9" className="text-center">Matrículas</th>
                                                                <th colSpan="9" className="text-center">Horas</th>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan="4" className="text-center">Meta (<span style={{ textTransform: "uppercase" }}>{mesSelecionado}</span>) </th>
                                                                <th colSpan="5" className="text-center">Realizado (<span style={{ textTransform: "uppercase" }}>{mesSelecionado}</span>) </th>
                                                                <th colSpan="4" className="text-center">Meta (<span style={{ textTransform: "uppercase" }}>{mesSelecionado}</span>) </th>
                                                                <th colSpan="5" className="text-center">Realizado (<span style={{ textTransform: "uppercase" }}>{mesSelecionado}</span>) </th>
                                                            </tr>
                                                            <tr>
                                                                {/*<th>Modalidades</th>*/}
                                                                <th>Matrículas Regimental</th>
                                                                <th>Matrículas Não-Regimental</th>
                                                                <th>Matrículas Pagas</th>
                                                                <th>Total</th>
                                                                <th>Matrículas Regimental</th>
                                                                <th>Matrículas Não-Regimental</th>
                                                                <th>Matrículas Pagas</th>
                                                                <th>Total</th>
                                                                <th>%</th>
                                                                <th>Hora Regimental</th>
                                                                <th>Hora Não-Regimental</th>
                                                                <th>Hora Pagas</th>
                                                                <th>Total</th>
                                                                <th>Hora Regimental</th>
                                                                <th>Hora Não-Regimental</th>
                                                                <th>Hora Pagas</th>
                                                                <th>Total</th>
                                                                <th>%</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {utils.retornaArrayModalidades().map((modal, j) => {

                                                                let valorM = valor["metas"][modal];
                                                                let valorR = valor["realizados"][modal];

                                                                return (
                                                                    <tr>
                                                                        <td className="text-start" style={{ backgroundColor: "#c5c0ad" }}>{modal}</td>
                                                                        <td>{this.formataNumeroNovo(valorM, "matricula_regimental", mesSelecionado)}</td>
                                                                        <td>{this.formataNumeroNovo(valorM, "matricula_nao_regimental", mesSelecionado)}</td>
                                                                        <td>{this.formataNumeroNovo(valorM, "matricula_pago", mesSelecionado)}</td>
                                                                        <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{this.formataNumeroNovo(valorM, null, mesSelecionado, true, "matricula")}</td>
                                                                        
                                                                        <td>{this.formataNumeroNovo(valorR, "matricula_regimental", mesSelecionado)}</td>
                                                                        <td>{this.formataNumeroNovo(valorR, "matricula_nao_regimental", mesSelecionado)}</td>
                                                                        <td>{this.formataNumeroNovo(valorR, "matricula_pago", mesSelecionado)}</td>
                                                                        <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{this.formataNumeroNovo(valorR, null, mesSelecionado, true, "matricula")}</td>
                                                                        <td style={{ fontWeight: "600", backgroundColor: "#9d9475"  }}>{this.formataPercentual(valorM, valorR, "matricula", mesSelecionado)}</td>
                                                                        
                                                                        <td>{this.formataNumeroNovo(valorM, "hora_regimental", mesSelecionado)}</td>
                                                                        <td>{this.formataNumeroNovo(valorM, "hora_nao_regimental", mesSelecionado)}</td>
                                                                        <td>{this.formataNumeroNovo(valorM, "hora_pago", mesSelecionado)}</td>
                                                                        <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{this.formataNumeroNovo(valorM, null, mesSelecionado, true, "hora")}</td>
                                                                        
                                                                        <td>{this.formataNumeroNovo(valorR, "hora_regimental", mesSelecionado)}</td>
                                                                        <td>{this.formataNumeroNovo(valorR, "hora_nao_regimental", mesSelecionado)}</td>
                                                                        <td>{this.formataNumeroNovo(valorR, "hora_pago", mesSelecionado)}</td>
                                                                        <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{this.formataNumeroNovo(valorR, null, mesSelecionado, true, "hora")}</td>
                                                                        <td style={{ fontWeight: "600", backgroundColor: "#9d9475"  }}>{this.formataPercentual(valorM, valorR, "hora", mesSelecionado)}</td>
                                                                    </tr>
                                                                )

                                                            })
                                                            }
                                                            <tr style={{ fontWeight: "700", backgroundColor: "#c5c0ad"  }}>
                                                                <td>Total</td>
                                                                <td>{utils.formataNumero(total["matricula_regimental"])}</td>
                                                                <td>{utils.formataNumero(total["matricula_nao_regimental"])}</td>
                                                                <td>{utils.formataNumero(total["matricula_pago"])}</td>
                                                                <td>{utils.formataNumero(total["matricula_pago"] + total["matricula_nao_regimental"] + total["matricula_regimental"])}</td>
                                                                <td>{utils.formataNumero(total["r_matricula_regimental"])}</td>
                                                                <td>{utils.formataNumero(total["r_matricula_nao_regimental"])}</td>
                                                                <td>{utils.formataNumero(total["r_matricula_pago"])}</td>
                                                                <td>{utils.formataNumero(total["r_matricula_regimental"] + total["r_matricula_nao_regimental"] + total["r_matricula_pago"])}</td>
                                                                <td>{utils.formataPercentualTotal(total, "matricula")}</td>
                                                                <td>{utils.formataNumero(total["hora_regimental"])}</td>
                                                                <td>{utils.formataNumero(total["hora_nao_regimental"])}</td>
                                                                <td>{utils.formataNumero(total["hora_pago"])}</td>
                                                                <td>{utils.formataNumero(total["hora_pago"] + total["hora_nao_regimental"] + total["hora_regimental"])}</td>
                                                                <td>{utils.formataNumero(total["r_hora_regimental"])}</td>
                                                                <td>{utils.formataNumero(total["r_hora_nao_regimental"])}</td>
                                                                <td>{utils.formataNumero(total["r_hora_pago"])}</td>
                                                                <td>{utils.formataNumero(total["r_hora_regimental"] + total["r_hora_nao_regimental"] + total["r_hora_pago"])}</td>
                                                                <td>{utils.formataPercentualTotal(total, "hora")}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Fragment>

                                        </Tab>
                                    )

                                })}

                            </Tabs>

                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}